"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const assets_1 = require("../assets");
const polished_1 = require("polished");
const styles_1 = require("../styles");
const chevronBottom = require('../../assets/chevronBottom.png');
const Select = ({ children, value, testID, onValueChange, style, selectStyle, }) => (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.pickerView, style]) },
    react_1.default.createElement(react_native_1.Picker, { testID: testID, selectedValue: value, itemStyle: { fontFamily: 'IranYekan-FD-Regular' }, onValueChange: onValueChange, style: react_native_1.StyleSheet.flatten([styles.select, selectStyle]) }, children),
    react_1.default.createElement(react_native_1.Image, { source: chevronBottom, style: styles.chevronIcon })));
Select.Item = react_native_1.Picker.Item;
exports.default = Select;
const styles = react_native_1.StyleSheet.create({
    pickerView: {
        backgroundColor: styles_1.Colors.background,
        // flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: assets_1.Shape.buttonBorderRadius,
        height: 37,
        paddingHorizontal: styles_1.getSpacing(0.5),
        marginRight: styles_1.getSpacing(0.5),
        width: '100%',
    },
    select: {
        backgroundColor: polished_1.rgba(0, 0, 0, 0),
        fontFamily: 'IranYekan-FD-Regular',
        fontSize: 12,
        flex: 1,
        // minWidth: '100%',
        color: styles_1.Colors.primary,
        ...react_native_1.Platform.select({
            web: {
                '-moz-appearance': 'none',
                '-webkit-appearance': 'none',
                border: 'none',
                cursor: 'pointer',
                marginBottom: styles_1.getSpacing(0.5),
            },
        }),
    },
    chevronIcon: {
        width: 15,
        height: 15,
        position: 'absolute',
        right: styles_1.getSpacing(0.5),
        zIndex: -1,
    },
});
